// Mirrors FONT_FAMILIES/BUTTON_STYLES/BORDER_RADII in pi_ecommerce_api's
// src/constants/branding.ts and the preset ids pi_ecommerce_store's
// lib/branding-presets.ts resolves to actual CSS values. Three independent
// repos, no shared package, so these ids are deliberately duplicated here
// rather than imported -- keep in sync by hand if a preset is added/removed.

export const FONT_FAMILY_OPTIONS = [
	{ value: 'geist', label: 'Geist (default)', css: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
	{ value: 'inter', label: 'Inter', css: "'Inter', sans-serif" },
	{ value: 'playfair', label: 'Playfair Display', css: "'Playfair Display', serif" },
	{ value: 'merriweather', label: 'Merriweather', css: "'Merriweather', serif" },
	{ value: 'poppins', label: 'Poppins', css: "'Poppins', sans-serif" },
];

// Preview-only -- must match pi_ecommerce_store's lib/branding-presets.ts
// BUTTON_RADIUS_BY_STYLE/RADIUS_BY_PRESET so what an admin sees here is what
// actually renders on the storefront.
export const BUTTON_STYLE_OPTIONS = [
	{ value: 'sharp', label: 'Sharp', radius: '0rem' },
	{ value: 'rounded', label: 'Rounded (default)', radius: '0.375rem' },
	{ value: 'pill', label: 'Pill', radius: '9999px' },
];

export const BORDER_RADIUS_OPTIONS = [
	{ value: 'none', label: 'None', radius: '0rem' },
	{ value: 'small', label: 'Small', radius: '0.25rem' },
	{ value: 'medium', label: 'Medium (default)', radius: '0.5rem' },
	{ value: 'large', label: 'Large', radius: '1rem' },
];

export const fontOption = (value) => FONT_FAMILY_OPTIONS.find((o) => o.value === value) || FONT_FAMILY_OPTIONS[0];
export const buttonStyleOption = (value) =>
	BUTTON_STYLE_OPTIONS.find((o) => o.value === value) || BUTTON_STYLE_OPTIONS[1];
export const borderRadiusOption = (value) =>
	BORDER_RADIUS_OPTIONS.find((o) => o.value === value) || BORDER_RADIUS_OPTIONS[2];
